import { queryOptions, useQuery } from '@tanstack/react-query';
import { LoopPlannerTimelineItemsApi } from '@/lib/api/loop-planner/timeline-items';
import { loopPlannerQueryKeys } from '@/lib/query-keys/loop-planner';

export const bulkFetchTimelineItemsQueryOptions = ({
  loopId,
  scenarioId,
  itemIds,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
}) =>
  queryOptions({
    queryKey: loopPlannerQueryKeys.timelineItems.bulkFetch({ loopId, scenarioId, itemIds }),
    queryFn: () => LoopPlannerTimelineItemsApi.bulkFetch({ loopId, scenarioId, itemIds }),
    enabled: itemIds.length > 0,
  });

export const useBulkFetchTimelineItems = ({
  loopId,
  scenarioId,
  itemIds,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
}) => {
  return useQuery(bulkFetchTimelineItemsQueryOptions({ loopId, scenarioId, itemIds }));
};
